import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  Button,
  Input,
  Toastr,
  Modal,
  Loader,
  GridContainer,
  GridColumn,
  GridRow,
} from "arv-reactcomponents";
import {
  processShippingDate,
  setLastUsedPincode,
  getlastUsedPincode,
} from "../../../utils";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

class PincodeBlock extends Component {
  constructor() {
    super();
    this.state = {
      isPincodeValid: false,
      pincode: "",
      modes: [],
      fulfillmentCenters: [],
      isModalOpen: false,
      pincodeErrorMsg: "",
      loader: false,
    };
    this.pincodeInput = null;
    this.pinCodeSubmit = this.pinCodeSubmit.bind(this);
    this.validatePincode = this.validatePincode.bind(this);
    this.openStoresModal = this.openStoresModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getPinCode = this.getPinCode.bind(this);
    this.resetData = this.resetData.bind(this);
  }
  componentDidMount() {
    this.getPinCode();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedSkuId !== this.props.selectedSkuId ||
      nextProps.styleId !== this.props.styleId
    ) {
      this.resetData();
      this.getPinCode();
    }
  }
  get isPincodeValid() {
    return !this.state.isPincodeValid;
  }
  get fcStores() {
    return this.state.fulfillmentCenters.map(fc => (
      <div className="nw-store-item" key={fc.fcId}>
        <span className="nw-item-bold">{fc.fcName}</span>
        <span>{fc.streetNo}</span>
        <span>
          {fc.town} - {fc.postCode}
        </span>
        <span>{fc.country}</span>
        <span className="nw-item-bold">
          {Math.round(fc.distance * 10) / 10} kms
        </span>
      </div>
    ));
  }
  get isPinCodeError() {
    return this.state.isPincodeValid ? "nwc-hide" : "";
  }
  get isLoader() {
    return this.state.loader ? "" : "nwc-hide";
  }

  getPinCode() {
    const pincode = getlastUsedPincode();
    const validatePincodeField = this.pincodeInput.getValidatedOutput(pincode);
    if (validatePincodeField.value.length < 6)
      validatePincodeField.isValid = false;
    if (validatePincodeField.isValid)
      this.setState({ pincode, isPincodeValid: validatePincodeField.isValid });
  }
  resetData() {
    this.setState({ modes: [], fulfillmentCenters: [], pincodeErrorMsg: "" });
  }
  openStoresModal() {
    this.setState({
      isModalOpen: true,
    });

    Analytics.trackEvent({
      action: Event.action.STORES_NEARBY_CLICK,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  pinCodeSubmit(e, initPincode, interaction = false) {
    if (e) {
      e.preventDefault();
    }
    const pincode = initPincode || this.state.pincode;
    const { selectedSkuId: skuId } = this.props;
    Analytics.trackEvent({
      action: Event.action.PINCODE_ENTERED,
      label: pincode,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
    if (!skuId) {
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message: "Hold on! What size do you want?",
        timeout: 3000,
      });

      Analytics.trackEvent({
        action: Event.action.PINCODE_CHECKED_SIZE_ISSUE,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });

      return null;
    }
    const skus = {
      skuId,
      qty: 1,
      quantity: 1,
    };
    const body = {
      skus: [skus],
      pincode,
    };
    this.setState({ loader: true, isPincodeValid: false });
    setLastUsedPincode(pincode);
    this.props.getShippingDetails(JSON.stringify(body)).then(res => {
      const { availableShippingMethods = [], fulfillmentCenters = [] } = res;
      if (availableShippingMethods && availableShippingMethods.length > 0) {
        const modes = processShippingDate(
          availableShippingMethods,
          fulfillmentCenters,
        );
        this.setState({
          modes,
          fulfillmentCenters,
          loader: false,
          isPincodeValid: true,
        });
        Analytics.trackEvent({
          action: Event.action.PINCODE_CHECKED,
          label: pincode,
          category: Event.category.PRODUCT_DESCRIPTION_PAGE,
          interaction,
        });
      } else {
        this.setState({
          pincodeErrorMsg:
            "Sorry we don't deliver to this pincode yet. Please try another one.",
          loader: false,
          isPincodeValid: false,
        });
        Analytics.trackEvent({
          action: Event.action.PINCODE_ERROR,
          label: pincode,
          category: Event.category.PRODUCT_DESCRIPTION_PAGE,
          interaction,
        });
      }
    });
    return null;
  }
  validatePincode(e) {
    const validatePincodeField = this.pincodeInput.getValidatedOutput(
      e.target.value,
    );
    if (validatePincodeField.value.length < 6)
      validatePincodeField.isValid = false;
    this.setState({
      isPincodeValid: validatePincodeField.isValid,
      pincode: validatePincodeField.value,
      modes: [],
      pincodeErrorMsg: validatePincodeField.errorMsg,
    });
    const { selectedSkuId: skuId } = this.props;
    if (validatePincodeField.isValid && skuId) {
      this.pinCodeSubmit(null, validatePincodeField.value);
    }
  }
  render() {
    const {
      pincode,
      fulfillmentCenters,
      isModalOpen,
      pincodeErrorMsg,
    } = this.state;
    const { className, inStock } = this.props;
    return (
      <div className={`nw-pdp-pincode ${className}`}>
        <div className="nw-pincode-header">DELIVERY OPTIONS :</div>
        <div className="nw-pincode-title">
          Enter your pincode to view shipping options
        </div>
        <form className="nw-pincode-btns" onSubmit={this.pinCodeSubmit}>
          <GridContainer>
            <GridRow>
              <GridColumn className="nw-pincode-inputblock nwc-grid-col-xs-7">
                <Input
                  className="nw-pincode-input"
                  name="pincode"
                  type="tel"
                  ref={values => {
                    this.pincodeInput = values;
                  }}
                  value={pincode}
                  maxLength={6}
                  minLength={6}
                  onChange={this.validatePincode}
                  disabled={!inStock}
                  validateWithPattern={[
                    {
                      pattern: /^[0-9]*$/,
                      msg:
                        "We need a valid 6-digit pincode. Try again, please.",
                    },
                  ]}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-xs-5">
                <div className="nw-pincode-checkbtn">
                  <Button
                    type="submit"
                    className="nw-pincode-btn nwc-btn-secondary"
                    disabled={this.isPincodeValid || !inStock}
                  >
                    CHECK
                  </Button>
                  <Loader className={`nw-pincode-loader ${this.isLoader}`} />
                </div>
              </GridColumn>
            </GridRow>
          </GridContainer>
          <div className={`nw-pincode-error ${this.isPinCodeError}`}>
            {pincodeErrorMsg}
          </div>
        </form>
        {this.state.modes.map(mode => {
          const storeLength = fulfillmentCenters.length;
          const store =
            mode.order === 0 && storeLength > 0 ? (
              <Button
                className={`nw-stores-length ${this.isStores}`}
                onClick={this.openStoresModal}
              >
                {storeLength} stores
              </Button>
            ) : (
              ""
            );
          return (
            <div className="nw-pincode-modes" key={mode.order}>
              <i className="icomoon-check nw-pincode-check" />
              <span className="nw-pincode-name">{mode.name}</span>
              {store}
              <Modal isOpen={isModalOpen} onClose={this.closeModal}>
                <div className="nw-store-header">
                  <div className="nw-store-title">Stores Near {pincode}</div>
                </div>
                {this.fcStores}
              </Modal>
            </div>
          );
        })}
      </div>
    );
  }
}
PincodeBlock.defaultProps = {
  selectedSkuId: "",
  className: "",
  styleId: "",
  inStock: false,
};
PincodeBlock.propTypes = {
  selectedSkuId: PropTypes.string,
  className: PropTypes.string,
  styleId: PropTypes.string,
  getShippingDetails: PropTypes.func.isRequired,
  inStock: PropTypes.bool,
};

export default PincodeBlock;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/PincodeBlock/index.js